import * as T from './appTokenTypes';

export interface AppTokenState {
  valid: boolean | null; // null = not yet validated
  loading: boolean;
  error: string | null;
}

const initialState: AppTokenState = {
  valid: null,
  loading: false,
  error: null,
};

export default function appTokenReducer(state = initialState, action: any): AppTokenState {
  switch (action.type) {
    case T.VALIDATE_APP_TOKEN_REQUEST:
      return { ...state, loading: true, error: null };
    case T.VALIDATE_APP_TOKEN_SUCCESS:
      return { ...state, loading: false, valid: action.payload, error: null };
    case T.VALIDATE_APP_TOKEN_FAILURE:
      return { ...state, loading: false, valid: false, error: action.payload };
    case T.RESET_APP_TOKEN:
      return initialState;
    default:
      return state;
  }
}
